module.exports = __webpack_public_path__ + "static/img/8.5bdff0f0.png";